<!-- Компактное обновление телеметрии в строке пробега ФАКТа. -->
<template>
  <button
    type="button"
    class="plan-telemetry-refresh"
    :disabled="disabled"
    aria-label="Обновить данные телеметрии"
    title="Обновить данные телеметрии"
    @click="$emit('click')"
  >
    <AppIcon name="sync" :size="14" aria-hidden="true" />
  </button>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "OrderPlanCalculationRefreshTelemetryButton",

  components: { AppIcon },

  props: {
    disabled: { type: Boolean, default: false },
  },

  emits: ["click"],
};
</script>

<style scoped>
.plan-telemetry-refresh {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #5b6070;
  cursor: pointer;
}

.plan-telemetry-refresh:hover:not(:disabled),
.plan-telemetry-refresh:focus-visible {
  background: #eef1f8;
  color: #3b5bdb;
  outline: none;
}

.plan-telemetry-refresh:disabled {
  color: #a3a9b8;
  cursor: default;
}
</style>
